// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"Footer_contactContainer__TlwSb","button":"Footer_button__3eMA1"};